const currentOrigin = window.location.origin;
let apiURL;
let googleAnalyticsId;
let clarityId;
let verifyBaseURL;

if (currentOrigin.includes('local')) {
  apiURL = 'http://localhost:8090';
  verifyBaseURL = ''; // empty = proxied through Angular dev server on same origin
} else if (currentOrigin.includes('dev')) {
  apiURL = 'https://atar-student-service.dev.qtac.io';
  verifyBaseURL = apiURL;
} else if (currentOrigin.includes('int')) {
  apiURL = 'https://atar-student-service.int.qtac.io';
  verifyBaseURL = apiURL;
} else if (currentOrigin.includes('qa')) {
  apiURL = 'https://atar-student-service.qa.qtac.io';
  verifyBaseURL = apiURL;
  googleAnalyticsId = 'G-7VS7B3Y5HL';
  clarityId = 'xigaxwo38u';
} else if (currentOrigin.includes('staging')) {
  apiURL = 'https://atar-student-service.staging.qtac.io';
  verifyBaseURL = apiURL;
} else if (currentOrigin.includes('o2beta')) {
  apiURL = 'https://atar-student-service.o2beta.qtac.edu.au';
  verifyBaseURL = apiURL;
} else if (currentOrigin.includes('prod')) {
  apiURL = 'https://atar-student-service.prod.qtac.edu.au';
  verifyBaseURL = apiURL;
  googleAnalyticsId = 'G-B8FG19SEG2';
  clarityId = 'xih46pvcj4';
} else {
  apiURL = 'https://atar-student-service.prod.qtac.edu.au';
  verifyBaseURL = apiURL;
}

export const environment = {
  production: false,
  apiURL: apiURL,
  googleAnalyticsId: googleAnalyticsId,
  clarityId: clarityId,
  verifyBaseURL: verifyBaseURL
};
